import { Injectable } from '@angular/core';
import { DeviceType } from './device-type-model';
import { RestDeviceTypesService } from 'src/app/service/rest/device-type/rest-device-types.service';
import { Observable } from 'rxjs';

@Injectable()
export class DeviceTypeRepositoryService {

  private _selectedDeviceType: DeviceType = null;
  private _deviceTypes: DeviceType[] = [];
  
  constructor(private restDeviceTypeService: RestDeviceTypesService) { }
  
  public get selectedDeviceType(): DeviceType {
    return this._selectedDeviceType;
  }
  public set selectedDeviceType(value: DeviceType) {
    this._selectedDeviceType = value;
  }
  
  public get deviceTypes(): DeviceType[] {
    return this._deviceTypes;
  }
  public set deviceTypes(value: DeviceType[]) {
    this._deviceTypes = value;
  }

  loadDeviceTypes(): Observable<DeviceType[]> {
    return this.restDeviceTypeService.getAllDeviceTypes();
  }

}
